<div class="max-w-2xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Contactez-nous</h1>
  <p class="text-gray-500 dark:text-gray-400 mb-8">
    Une question, un problème ou une suggestion ? Écrivez-nous.
  </p>
  @if (sent) {
    <div
      class="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-xl text-green-700 dark:text-green-300 text-sm"
    >
      ✅ Message envoyé ! Nous vous répondrons sous 24-48h.
    </div>
  } @else {
    <form (ngSubmit)="submit()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nom</label>
        <input
          [(ngModel)]="form.name"
          name="name"
          required
          class="w-full border border-gray-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >Email</label
        >
        <input
          [(ngModel)]="form.email"
          name="email"
          type="email"
          required
          class="w-full border border-gray-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >Sujet</label
        >
        <select
          [(ngModel)]="form.subject"
          name="subject"
          class="w-full border border-gray-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          <option value="support">Support technique</option>
          <option value="billing">Facturation</option>
          <option value="feature">Demande de fonctionnalité</option>
          <option value="other">Autre</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >Message</label
        >
        <textarea
          [(ngModel)]="form.message"
          name="message"
          rows="5"
          required
          class="w-full border border-gray-300 dark:border-slate-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
        ></textarea>
      </div>
      <button
        type="submit"
        class="w-full py-3 bg-purple-600 text-white rounded-xl font-semibold hover:bg-purple-700 transition"
      >
        Envoyer le message
      </button>
    </form>
  }
</div>
